import { Alert, Button, Snackbar } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { selectIsVersionOutOfDate } from "src/store/slices/versionSlice";
import { useAppSelector } from "src/store/store";

export const OutOfDateSnackbar = () => {
  const isOutOfDate = useAppSelector(selectIsVersionOutOfDate);
  const { t } = useTenantTranslation();

  return (
    <Snackbar
      open={isOutOfDate}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        severity="warning"
        action={
          <Button
            color="primary"
            size="medium"
            onClick={() => {
              window.location.reload();
            }}
          >
            {t("refresh")}
          </Button>
        }
      >
        {t("newVersionNotification")}
      </Alert>
    </Snackbar>
  );
};
